import VueCookies from "vue-cookies";
import {
  claimsFromTokenPayload,
  isAdminFromTokenPayload,
  parseJwtPayload,
  rolesFromStorage,
  rolesFromTokenPayload,
  userFromTokenPayload,
} from "../../../utils/authToken";

let isAdmin = false;
let claims = "";
let user = "";
let branch = "";
let name = "";
let emailAddress = "";
let utaPhone = "";
let plivoPhone = "";
let roles = [];

const token = VueCookies.get("user-token");
if (token != null) {
  const tokenPayload = parseJwtPayload(token);
  if (tokenPayload) {
    isAdmin = isAdminFromTokenPayload(tokenPayload);
    claims = claimsFromTokenPayload(tokenPayload);
    user = userFromTokenPayload(tokenPayload);
    roles = rolesFromTokenPayload(tokenPayload);
    branch = tokenPayload.branch || "";
    emailAddress = tokenPayload.emailAddress || "";
    name = tokenPayload.name || "";
    utaPhone = tokenPayload.utaPhone || "";
    plivoPhone = tokenPayload.plivoPhone || "";
  }
}

if (!roles.length) {
  roles = rolesFromStorage(localStorage.getItem("user-roles"));
} else {
  localStorage.setItem("user-roles", JSON.stringify(roles));
}

export default {
  token: token || "",
  roles: roles,
  status: "",
  user: user || "",
  claims: claims || "",
  isAdmin: isAdmin || false,
  utaPhone: utaPhone || "",
  name: name || "",
  branch: branch || "",
  plivoPhone: plivoPhone || "",
  emailAddress: emailAddress || "",
};
